import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import OuraNav from "../components/OuraNav";
import OuraSecondNav from "../components/OuraSecondNav";
import fetchBase from "../utils/fetchBase";
import "./DocumentListPage.css";



export default function DocumentListPage() {
    const { hubId, sectionId } = useParams();
    const [section, setSection] = useState(null);
    const [hub, setHub] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [assignMessage, setAssignMessage] = useState(null);
    const [editingTitle, setEditingTitle] = useState(false);
    const [titleDraft, setTitleDraft] = useState("");
    const navigate = useNavigate();



    const token = localStorage.getItem("jwt_token");
    const authHeader = `Bearer ${token}`;

    const fetchDocuments = async () => {
        try {
            const [hubRes, sectionRes, docsRes] = await Promise.all([
                fetch(`${fetchBase}/api/document-hub/hubs/${hubId}`, { headers: { Authorization: authHeader } }),
                fetch(`${fetchBase}/api/document-hub/sections/${sectionId}`, { headers: { Authorization: authHeader } }),
                fetch(`${fetchBase}/api/document-hub/sections/${sectionId}/documents`, { headers: { Authorization: authHeader } })
            ]);
            const hubData = await hubRes.json();
            const sectionData = await sectionRes.json();
            const docsData = await docsRes.json();
            setHub(hubData);
            setSection(sectionData);
            if (Array.isArray(docsData)) setDocuments(docsData);
        } catch (err) {
            console.error("Failed to fetch documents:", err);
        } finally {
            setLoading(false);
        }
    };

        useEffect(() => {
            fetchDocuments();
            setSelectedIds([]);
        }, [sectionId]);

        const toggleSelect = (docId) => {
            setSelectedIds(prev =>
                prev.includes(docId) ? prev.filter(id => id !== docId) : [...prev, docId]
            );
        };

        const handleSelectAll = (checked) => {
            setSelectedIds(checked ? documents.map(d => d.id) : []);
        };


    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setUploading(true);
        const formData = new FormData();
        formData.append("file", file);
        try {
            const res = await fetch(`${fetchBase}/api/document-hub/sections/${sectionId}/documents`, {
                method: "POST",
                headers: { Authorization: authHeader },
                body: formData
            });
            if (res.ok) fetchDocuments();
        } catch (err) {
            console.error("Upload failed:", err);
        } finally {
            setUploading(false);
        }
    };

        const handleDeleteDocument = async (e, id) => {
            e.stopPropagation();
            if (!window.confirm("Delete this document?")) return;
            try {
                await fetch(`${fetchBase}/api/document-hub/documents/${id}`, {
                    method: "DELETE",
                    headers: { Authorization: authHeader }
                });
                fetchDocuments();
            } catch (err) {
                console.error("Failed to delete document:", err);
            }
        };

            const handleMakeDynamic = async (selectedTargets, config) => {
                try {
                    const res = await fetch(`${fetchBase}/api/document-hub/documents/make-dynamic`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: authHeader
                        },
                        body: JSON.stringify({
                            documentIds: selectedIds,
                            targets: selectedTargets,
                            assignmentTitle: config.assignmentTitle,
                            frequency: config.frequency,
                            startDate: config.startDate,
                            instructions: config.instructions
                        })
                    });
                    if (res.ok) {
                        const names = selectedTargets.map(t => t.name).filter(Boolean);
                        const nameText = names.length > 0 ? names.join(", ") : "the selected employee(s)";
                        setAssignMessage(`Dynamic assignment "${config.assignmentTitle}" created for ${nameText}.`);
                        setSelectedIds([]);
                    } else {
                        console.error("Make dynamic failed:", await res.text());
                    }
                } catch (err) {
                    console.error("Failed to make dynamic:", err);
                }
            };

            const handleAssign = async (selectedTargets) => {
                try {
                    const res = await fetch(`${fetchBase}/api/document-hub/documents/assign`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: authHeader
                        },
                        body: JSON.stringify({
                            documentIds: selectedIds,
                            targets: selectedTargets
                        })
                    });
                        if (res.ok) {
                            const names = selectedTargets.map(t => t.name).filter(Boolean);
                            const nameText = names.length > 0 ? names.join(", ") : "the selected member(s)";
                            setAssignMessage(`Document assigned to ${nameText}. Check Members in Document Hub to view.`);
                            setSelectedIds([]);
                        } else {

                        console.error("Assign failed:", await res.text());
                    }
                } catch (err) {
                    console.error("Failed to assign documents:", err);
                }
            };



    return (
        <div style={{ backgroundColor: "#f2f2f7", minHeight: "100vh" }}>
            <OuraNav
                links={[
                    { label: "Dashboard", href: "/admin-dashboard" },
                    { label: "Employees", href: "/employees" },
                    { label: "Clients", href: "/admin/clients" },
                    { label: "Scheduler", href: "/scheduler" },
                    { label: "Payroll", href: "/admin/payroll" }
                ]}
            />
            <OuraSecondNav
                mode="actions"
                selectedCount={selectedIds.length}
                allSelected={documents.length > 0 && selectedIds.length === documents.length}
                onSelectAll={handleSelectAll}
                onAssign={handleAssign}
                onMakeDynamic={handleMakeDynamic}
            />


            <div style={{ maxWidth: 900, margin: "0 auto", padding: "88px 40px 40px" }}>


                {assignMessage && (
                    <div style={{
                        background: "#e8f5e9",
                        color: "#1b5e20",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "500",
                        marginBottom: "16px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "12px"
                    }}>
                        <span>{assignMessage}</span>
                        <button
                            onClick={() => setAssignMessage(null)}
                            style={{
                                background: "none",
                                border: "none",
                                color: "#1b5e20",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "700",
                                padding: 0
                            }}
                        >
                            ✕
                        </button>
                    </div>
                )}


                {/* Breadcrumb */}
                <div style={{ fontSize: "13px", color: "#6e6e73", marginBottom: "24px", display: "flex", alignItems: "center", gap: "6px" }}>

                    <span onClick={() => navigate("/document-hub")} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>Document Hub</span>
                    <span>›</span>
                    <span onClick={() => navigate(`/document-hub/${hubId}`)} style={{ cursor: "pointer", color: "#0071e3", fontWeight: "500" }}>{hub?.name}</span>
                    <span>›</span>
                    <span style={{ color: "#1d1d1f", fontWeight: "500" }}>{section?.name}</span>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px" }}>
                    {editingTitle ? (
                        <input
                            autoFocus
                            value={titleDraft}
                            onChange={(e) => setTitleDraft(e.target.value)}
                            onBlur={async () => {
                                const newName = titleDraft.trim();
                                setEditingTitle(false);
                                if (!newName || newName === section?.name) return;
                                try {
                                    const res = await fetch(`${fetchBase}/api/document-hub/sections/${sectionId}/rename`, {
                                        method: "PATCH",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: authHeader
                                        },
                                        body: JSON.stringify({ name: newName })
                                    });
                                    if (res.ok) {
                                        setSection(prev => ({ ...prev, name: newName }));
                                    }
                                } catch (err) {
                                    console.error("Failed to rename section:", err);
                                }
                            }}
                            onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
                            style={{
                                fontSize: "28px", fontWeight: "700", color: "#1d1d1f",
                                border: "none", borderBottom: "2px solid #0071e3",
                                background: "transparent", outline: "none",
                                padding: 0, margin: 0, fontFamily: "inherit", width: "60%"
                            }}
                        />
                    ) : (
                        <h1
                            onClick={() => { setTitleDraft(section?.name || ""); setEditingTitle(true); }}
                            style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f", margin: 0, cursor: "text" }}
                        >{section?.name}</h1>
                    )}
                    <label style={{
                        padding: "9px 20px",
                        backgroundColor: "#1d1d1f",
                        color: "#fff",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor: "pointer"
                    }}>
                        {uploading ? "Uploading..." : "+ Upload Document"}
                        <input type="file" accept=".pdf,.doc,.docx" onChange={handleUpload} style={{ display: "none" }} />
                    </label>
                </div>

                {loading ? (
                    <p style={{ color: "#6e6e73", fontSize: "14px" }}>Loading...</p>
                ) : documents.length === 0 ? (
                    <p style={{ color: "#6e6e73", fontSize: "14px" }}>No documents yet. Upload a PDF to get started.</p>
                ) : (
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "20px" }}>
                        {documents.map(doc => {
                            const isSelected = selectedIds.includes(doc.id);
                            return (
                                <div
                                    key={doc.id}
                                    className="doc-card-hover-select"
                                    onClick={() => {
                                        if (doc.fileType === "DOCX" || doc.fileType === "DOC") {
                                            navigate(`/document-hub/${hubId}/sections/${sectionId}/documents/${doc.id}/word`);
                                        } else {
                                            navigate(`/document-hub/${hubId}/sections/${sectionId}/documents/${doc.id}`);
                                        }
                                    }}
                                    style={{
                                        background: "#fff",
                                        borderRadius: "14px",
                                        padding: "24px 20px",
                                        border: isSelected ? "1px solid #0071e3" : "1px solid #e0e0e0",
                                        cursor: "pointer",
                                        position: "relative",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                                        transition: "box-shadow 0.2s, border-color 0.2s"
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)"}
                                    onMouseLeave={e => e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"}
                                >
                                    <input
                                        type="checkbox"
                                        className="doc-card-checkbox"
                                        checked={isSelected}
                                        onClick={(e) => e.stopPropagation()}
                                        onChange={() => toggleSelect(doc.id)}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            left: "10px",
                                            cursor: "pointer",
                                            width: "16px",
                                            height: "16px"
                                        }}
                                    />
                                    <div style={{ fontSize: "28px", marginBottom: "12px" }}>
                                        {doc.fileType === "DOCX" || doc.fileType === "DOC" ? "📝" : "📄"}
                                    </div>
                                    <p style={{ fontWeight: "600", fontSize: "13px", color: "#1d1d1f", margin: 0, wordBreak: "break-word" }}>{doc.filename}</p>
                                    <p style={{ fontSize: "11px", color: "#6e6e73", marginTop: "6px" }}>{doc.uploadedDate}</p>
                                    <button
                                        onClick={(e) => handleDeleteDocument(e, doc.id)}
                                        style={{ position: "absolute", top: "10px", right: "10px", background: "none", border: "none", color: "#ff3b30", fontSize: "13px", cursor: "pointer", fontWeight: "700" }}
                                    >✕</button>
                                </div>
                            );
                        })}
                    </div>

                )}
            </div>
        </div>
    );
}